<template>
  <div class="login" id="login">
    <div class="login-form">
      <div class="form-left">
        <img src="@/assets/img/loginLogo.png" alt="">
        <div class="name">
          <span>友友圈</span>
          <span>代理商后台管理系统</span>
        </div>
      </div>
      <div class="formCon">
        <form class="ruleForm">
          <p>后台登录</p>
          <el-form :model="ruleForm" :rules="rule">
            <el-form-item class="el-phone" prop="phone">
              <el-input v-model="ruleForm.phone" placeholder="手机号" prefix-icon="icon-phone" class="phone" @keydown="login($event)"></el-input>
            </el-form-item>
            <el-form-item class="el-code" prop="code">
              <el-input v-model="ruleForm.code" placeholder="验证码" prefix-icon="icon-code" class="code" @keydown="login($event)"></el-input>
              <el-button  :disabled='isDisabled' class="sendCode" type="button"  @click="phoneCode">{{btnText}}</el-button>
            </el-form-item>
          </el-form>
          <button class="submit" type="button" @click="login">登录</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  // 手机号：19999999999  验证码：180803
  import axios from 'axios'
  import $ from 'jquery'
  import {delCookie,getCookie,setCookie} from '@/util/util'

  export default {
    name: "login", 
    // name:'div-code',
    data(){
      // <!--验证手机号是否合法-->
      let checkPhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入手机号码'))
        } else if (!this.checkMobile(value)) {
          callback(new Error('手机号码不合法'))
        } else {
          callback()
        }
      }
      return{
        phone:'',
        code:'',
        btnDisabled:false,
        btnText:'获取验证码',
        isDisabled: false, // 是否禁止点击发送验证码按钮
        flag:true,
        ruleForm:{
          phone:"",
          code:""
        },
        rule: {
          phone: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { validator: checkPhone, trigger: 'change' }],
          code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        },
      }
    },
    methods: {
      // 验证手机号
      checkMobile(str) {
        let re = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/
        if (re.test(str)) {
          return true;
        } else {
          return false;
        }
      },
      // 键盘事件
      login(ev){
        if(ev.keyCode == 13) {  //键盘回车的编码是13
            this.login();
        }
      },
      // 获取验证码
      phoneCode(){
        let phone = this.ruleForm.phone
        if (this.checkMobile(phone)) {
          // console.log(phone)
          let time = 60
          this.btnText = '已发送'
          this.isDisabled = true
          if (this.flag) {
            this.flag = false;
            let timer = setInterval(() => {
              time--;
              this.btnText = time + 's'
              if (time === 0) {
                clearInterval(timer);
                this.btnText = '重新获取'
                this.isDisabled = false
                this.flag = true;
              }
            }, 1000)
          }
        }
        const url ='/scene/phoneCode';
        var params = new URLSearchParams();
        params.append('phoneNum',phone);
        this.$axios({
          method: 'post',
          url:url,
          data:params
        }).then((res)=>{
          console.log(res.data)
        })
      },
      // 登录
      login(){
        var phone=$('.phone>.el-input__inner').val();
        var code=$('.code>.el-input__inner').val();
        const url ='/account/login';
        var params = new URLSearchParams();
        params.append('userName', phone);       
        params.append('phoneCode', code);
        this.$axios({
            method: 'post',
            url:url,
            data:params
        }).then((res)=>{
            if(res.data.retCode!= 200) {
              console.log(res.data.retDesc);
            } else {
              let expireDays = 1000 * 60 * 60 ;
              // 获取token
              setCookie('session',res.data.data.token,expireDays);
              // 获取userType
              setCookie('userType',res.data.data.userType,expireDays);
              // console.log(getCookie('session'));
              console.log(res.data.data.userType);
              this.$router.push('/Index');
            }
            
            // if('userType'==2||'userType'==3){
            //     $(".Subpro").css('display','none');
            //     var Subpro=$('.Subpro').text();
            //     console.log(Subpro)
            //   }else if('userType'==4){
            //     $(".Personnel").css('display','none');
            //     $(".Account").css('display','none');
            //     $(".Subpro").css('display','none');
            //   }
        });
      }
    }
  }
</script>
<style scoped lang="scss">
  .ruleForm span{
    font-size: 0.16rem;
    color: red;
    display: none;
  }
  .login{
    width:19.2rem;
    height:10.8rem; 
    background: url("../assets/img/bg.png") no-repeat;
    background-size: 19.2rem 10.8rem;
    position: relative;
  }
  .login-form{
    width:11.3rem;
    height:5.68rem;
    background:rgba(255,255,255,0.68);
    box-shadow:0 0.07rem 0.08rem 0 rgba(185,0,44,0.68);
    border-radius:0.14rem;
    position: absolute;
    top: 2.61rem;
    left:3.91rem;
  }
  .form-left{
    float: left;
  }
  .form-left>img{
    width: 2.99rem;
    height: 1.41rem;
    margin: 1.49rem 1.66rem 0.28rem 1.74rem;
  }
  .form-left>.name{
    height:0.65rem;
    font-size:0.3rem;
    line-height: 0.4rem;
    font-family:STHeitiSC-Medium;
    font-weight:500;
    color:rgba(244,57,65,1);
  }
  .form-left>.name>span{
    text-align: center;
    display: block;
  }
  .formCon{
    width:4.97rem;
    height:5.68rem;
    background:rgba(255,255,255,1);
    border-radius:0 0.14rem 0.14rem 0;
    margin-left: 6.32rem;
  }
  .ruleForm{
    padding: 0.89rem 0.49rem 0.74rem 0.5rem;
    height: 4.94rem;
  }
  .ruleForm>p{
    height:0.34rem;
    font-size:0.36rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(48,48,48,1);
    line-height:0.35rem;
    padding-left:1.31rem;
    margin-bottom: 0.4rem;
  }
  .ruleForm>div{
    position: relative;
  }

  .ruleForm .div-phone{
    position: relative;
  }
  .icon-phone{
    display: inline-block;
    width: 0.18rem;
    height: 0.27rem;
    /*position: absolute;*/
    background:url("../assets/img/phone.png"); 
    background-size: 0.18rem 0.27rem;
    margin: 0.16rem 0.1rem 0 0.1rem;
    /*border:0.01rem dashed rgba(183,183,183,1);*/
  }
  .icon-code{
    display: inline-block;
    width: 0.21rem;
    height: 0.28rem;
    position: absolute;
    background:url("../assets/img/code.png"); 
    background-size: 0.21rem 0.28rem;
    margin: 0.15rem 0.7rem 0 0.1rem;
    /*border:0.01rem dashed rgba(183,183,183,1);*/
  }
  .ruleForm>div>input{
    width:3.98rem;
    height:0.59rem;
    border:0.01rem solid rgba(181,181,181,1);
    text-indent: 0.38rem;
    font-size:0.24rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
  }
  input::-webkit-input-placeholder{
    font-size:0.24rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(189,189,189,1);
  }
  .ruleForm .phone{
    /*margin-bottom: 0.33rem;*/
  }
  .ruleForm .code{
    width:2.34rem;
    height:0.59rem;
    /*border:0.01rem solid rgba(181,181,181,1);*/
    float: left;
    margin-right: 0.11rem;
  }
  .ruleForm>div>button{
    width:1.53rem;
    height:0.59rem;
    border:0.01rem solid rgba(181,181,181,1);
    font-size:0.24rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(189,189,189,1);
    line-height:0.35rem;
    background: #fff;
    float: left;
  }
  button>a{
    color: #fff;
  }
  .submit{
    border-radius: 0;
    width:3.98rem;
    height:0.59rem;
    background:rgba(249,47,60,1);
    font-size:0.32rem;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:0.35rem;
    letter-spacing: 0.2rem;
    margin-top: 1rem;
  }  
</style>

<style type="text/css">
  .login .el-input__prefix{
    display: inline-block;
    width: 0.18rem;
    height: 0.27rem;
  }
  .login .el-input__prefix .icon-phone{
    display: inline-block;
    width: 0.18rem;
    height: 0.27rem;
    background:url("../assets/img/phone.png"); 
    background-size: 0.18rem 0.27rem;
    margin: 0.16rem 0.1rem 0 0.1rem;
  }
  .login .el-input__prefix{
    display: inline-block;
    width: 0.18rem;
    height: 0.27rem;
  }
  .login .el-input__prefix .icon-code{
    display: inline-block;
    width: 0.18rem;
    height: 0.27rem;
    background:url("../assets/img/code.png"); 
    background-size: 0.18rem 0.27rem;
    margin: 0.16rem 0.1rem 0 0.1rem;
  }
  .login .ruleForm .el-form{
    height: 1.51rem;
  }
  .login .ruleForm .sendCode>span{
    text-align: center;
    width: 1.53rem;
    /*height:0.24rem;*/
    /*font-size:0.24rem;*/
    padding: 0;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(189,189,189,1);
  }
  .login .ruleForm .el-button{
    width: 1.53rem;
    height: 0.59rem;
    border:1px solid rgba(181,181,181,1);
    border-radius: 0;
    float: right;
  }
  .login .ruleForm .el-code .el-input{
    float: left;
    width: 2.34rem;
  }
  .login .ruleForm .el-code .ruleForm .el-input__inner{
    float: left;
  }
  .login .ruleForm .el-form-item{
    margin-bottom: 0;
  }
  .login .ruleForm .el-input__inner{
    border:1px solid rgba(181,181,181,1);
    border-radius: 0;
    height: 0.59rem;
    line-height: 0.59rem;
    padding: 0;
    font-size:0.24rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(189,189,189,1);
    text-indent: 0.45rem;
  }
  .login .ruleForm .el-phone{
    width: 3.98rem;
    height: 0.59rem;
    border:0;
    border-radius: 0;
    margin-bottom: 0.5rem;
  }
  .login .ruleForm .el-code{
    width: 3.98rem;
    height: 0.59rem;
    border:0;
    border-radius: 0;
    float: left;
  }
  .login .ruleForm .el-phone .el-form-item__content{
    height: 0.59rem;
  }
  .login .ruleForm .el-code .el-form-item__content{
    height: 0.59rem;
  }
</style>
 


// WEBPACK FOOTER //
// src/views/login.vue